import React from 'react'
import Commoninformation from '../Pagehome/Commoninformation'
import { Link } from 'react-router-dom'
import Icons from '../../components/icons';

const Cookiespolicy = () => {
    return (
        <>
            {/* <Commoninformation /> */}
            <div className='container-lg'>
                {/*breadcrunb start*/}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li><span><Icons.SlashSvg /></span></li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Cookies Policy
                        </li>
                    </ol>
                </nav>
                {/*breadcrunb End*/}
            </div>
            <div className='innerpages-section padding-50'>
                <div className='container-lg'>

                    <div className='flex-box justify-center mb-4'>
                        <div className='custom-heading  text-center '>
                            Cookies Policy
                        </div>
                    </div>

                    <div className='inp-inner'>

                        <div className='custom-text ct-small'>
                            This policy explains how we use cookies and similar tools to enhance your experience and deliver relevant updates across the <strong>United Kingdom</strong>.
                        </div>

                        <div className='custom-heading ch-medium'>1. Understanding Cookies</div>
                        <div className='custom-text ct-small'>
                            Cookies are small files stored on your device that help improve website performance, remember your preferences, and analyze user behavior.
                        </div>

                        <div className='custom-heading ch-medium'>2. Purpose of Cookies</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li>Optimize <strong>site functionality</strong> and browsing experience</li>
                            <li>Display content relevant to <strong>UK developments and updates</strong></li>
                            <li>Understand audience interactions to refine content and layout</li>
                            <li>Protect against unauthorized access and maintain security</li>
                        </ul>

                        <div className='custom-heading ch-medium'>3. Types of Cookies</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li><strong>Essential Cookies:</strong> Necessary for basic platform operations</li>
                            <li><strong>Performance Cookies:</strong> Monitor usage to enhance content and design</li>
                            <li><strong>Advertising Cookies:</strong> Deliver targeted promotions and sponsored content</li>
                            <li><strong>Preference Cookies:</strong> Retain settings like language, location, and other preferences</li>
                        </ul>

                        <div className='custom-heading ch-medium'>4. Managing Cookies</div>
                        <div className='custom-text ct-small'>
                            You can accept, block, or delete cookies through your browser settings. Certain features may not function fully if cookies are disabled.
                        </div>

                        <div className='custom-heading ch-medium'>5. Policy Updates</div>
                        <div className='custom-text ct-small'>
                            This policy may be revised occasionally to reflect new technologies or regulations. The latest version will always be available on this page.
                        </div>
                        <div className='custom-text ct-small'>
                            By using <strong>Forbes</strong>, you consent to our use of cookies for a <strong>secure, tailored, and informative UK experience.</strong>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Cookiespolicy